import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from 'theme-ui'

import media from './../../../common/MediaQueries'
import { WithTheme } from './../../../setup/index'
import { PillarStyleProps } from './types'

const PillarMaskStyled = styled.div<WithTheme>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  z-index: 2;
  background-color: ${({ theme }) => theme.colors.green};
  padding: 3.625rem 1.625rem 2.625rem;
  transition: 0.25s ease-out;
  overflow-x: hidden;
  overflow-y: auto;
  transform: translateY(-100%);

  -ms-overflow-style: none;
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
`

const PillarMaskContentStyled = styled(Text)<WithTheme>`
  color: ${({ theme }) => theme.colors.white};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  text-align: center;
`

const PillarFrontStyled = styled.div`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  padding: 2.625rem 2.25rem 2rem;

  @media ${media.tablet} {
    padding: 3.25rem 2.25rem 1.875rem;
  }
`

const PillarFrontIconStyled = styled.div`
  display: flex;
  align-items: flex-end;
  margin-bottom: 1.5rem;
  min-height: 9.375rem;
  max-height: 9.375rem;

  @media ${media.tablet} {
    margin-bottom: 2.5rem;
  }
`

const PillarFrontTitleStyled = styled(Text)<WithTheme>`
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  text-align: center;
  margin-bottom: 2.25rem;
`

const PillarFrontArrowStyled = styled.div<WithTheme>`
  display: flex;
  margin-top: auto;
  color: ${({ theme }) => theme.colors.green};
`

const PillarStyled = styled.div<WithTheme<PillarStyleProps>>`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  border-radius: 0.3125rem;
  box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.31);
  width: 100%;
  min-height: 22.125rem;
  background-color: ${({ theme }) => theme.colors.white};
  overflow: hidden;
  cursor: pointer;

  @media ${media.tablet} {
    min-height: 26.875rem;
    &:hover {
      ${PillarMaskStyled} {
        transform: none;
      }
    }
  }

  @media ${media.desktop} {
    min-height: 23.875rem;
  }

  ${({ isOpened }) =>
    isOpened &&
    css`
      @media ${media.maxTablet} {
        ${PillarMaskStyled} {
          transform: none;
        }
      }
    `};
`

export {
  PillarStyled,
  PillarMaskStyled,
  PillarMaskContentStyled,
  PillarFrontStyled,
  PillarFrontIconStyled,
  PillarFrontTitleStyled,
  PillarFrontArrowStyled
}
